module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user/customer/shared/customer-form/customer-form.component.html
// module id = ./src/app/user/customer/shared/customer-form/customer-form.component.html
// module chunks = main